import AKModal from '@atlaskit/modal-dialog';
import React, { FunctionComponent } from 'react';

const ModalContainer: FunctionComponent = ({children}) => <div className="react-modal">{children}</div>

type Props = {} & React.ComponentProps<typeof AKModal>;

const Modal: React.FC<Props> = (props) => {
  return (
      <AKModal {...props} testId={"react-modal"}/>
  )
};

export default Modal;
